import type { JSX } from "react";

import { formatShortcutKeys } from "@frontend/hooks/useKeyboardShortcut";

import { Kbd } from "./Kbd";
import type { KbdShortcutProps } from "./Kbd.types";
import { KbdGroup } from "./KbdGroup";

export function KbdShortcut({
  shortcut,
  ...props
}: KbdShortcutProps): JSX.Element {
  return (
    <KbdGroup {...props}>
      {formatShortcutKeys(shortcut).map((label) => (
        <Kbd key={label}>{label}</Kbd>
      ))}
    </KbdGroup>
  );
}
